import styled from "@emotion/styled";

import { BaseLink } from "~/components/common/base-link";

import LogoPosties from "./icon-logo-posties.svg";
import { PostiesHeaderMenu } from "./posties-header-menu";

export const Container = styled.div`
  block-size: 138px;
  max-inline-size: 1560px;
  border-block-end: 2px solid #d9d9d9;

  margin-block: 0;
  margin-inline: auto;
  padding-block-start: 32px;
  padding-inline-start: 64px;
  padding-inline-end: 35px;
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledLogoLink = styled(BaseLink)`
  margin-inline-end: 157px;
`;

export const StyledLogoPosties = styled(LogoPosties)`
  display: inline-block;

  inline-size: 246px;
  block-size: 46px;
`;

export const StyledPostiesHeaderMenu = styled(PostiesHeaderMenu)`
  flex: 1;
`;
